var _defs, _title, _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var Svg404201 = function Svg404201(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 800,
    viewBox: "0 0 100 800",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f99f24;}.b{fill:#ffca74;}"))), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "404-2")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M25,766.5A10.5118,10.5118,0,0,1,14.5,756L36.8989,41.647c.0005-3.4063,1.6529-5.7471,3.1363-5.7471h18.93c1.4834,0,3.1358,2.3408,3.1358,5.7l22.4,714.4468A10.5032,10.5032,0,0,1,74,766.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M58.9648,37.4c.3237.0238,1.6356,1.4325,1.6356,4.2v.047l.0015.047L83,756.0426A9.01,9.01,0,0,1,74,765H25a9.01,9.01,0,0,1-9-8.9574L38.3981,41.694l.0015-.047V41.6c0-2.7675,1.3119-4.1762,1.6357-4.2H58.9648m0-3H40.0353c-2.55,0-4.6357,3.24-4.6357,7.2L13,756a12.0353,12.0353,0,0,0,12,12H74a12.0353,12.0353,0,0,0,12-12L63.6,41.6c0-3.96-2.0861-7.2-4.6357-7.2Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg404201, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/404-2-01.917fe515.svg";
export { ForwardRef as ReactComponent };